export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7933.0c0abe2a.jpg";